// extracted by mini-css-extract-plugin
export var container = "_6z-0";
export var error = "_6z-9";
export var label = "_6z-5";
export var light = "_6z-6";
export var md = "_6z-3";
export var sm = "_6z-2";
export var thin = "_6z-8";
export var thinBold = "_6z-7";
export var vertical = "_6z-4";
export var xs = "_6z-1";